import type { PoolTable } from './table.types'
import type { User } from './user.types'
import type { TableType } from './table.types'

export const BookingStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
    NO_SHOW: 'NO_SHOW',
} as const

export type BookingStatus = typeof BookingStatus[keyof typeof BookingStatus]

export interface Booking {
    id: number
    table?: PoolTable
    tableId?: number | null
    tableName?: string | null
    tableType?: TableType
    user?: User
    userId?: number
    userName?: string
    userPhone?: string
    guestName?: string
    guestPhone?: string
    startTime: string
    durationMinutes: number
    status: BookingStatus
    confirmedAt?: string | null
    createdAt?: string
    notes?: string | null
}

export interface AvailabilityGridSlot {
    startTime: string
    totalTables: number
    occupiedCount: number
    pendingCount: number
    freeTableIds: number[]
    occupancyRatio: number
    pendingTableIds: number[]
}

export interface AvailabilityGridDay {
    date: string
    today: boolean
    slots: AvailabilityGridSlot[]
}

export interface TableSessionAvailability {
    tableId: number
    tableName: string
    sessionStart: string
    plannedEnd?: string | null
    firstBookableSlot?: string | null
}

export interface AvailabilityGrid {
    slotMinutes: number
    clubOpen: string
    clubClose: string
    days: AvailabilityGridDay[]
    tableSessions: TableSessionAvailability[]
}

export interface BookingFilters {
    tableType: TableType | null
    startDate: string
}

export interface CreateBookingRequest {
    tableId: number
    startTime: string
    durationMinutes: number
    userId?: number
    guestName?: string
    guestPhone?: string
}

export interface CreateUserBookingRequest {
    tableType: TableType
    startTime: string
    durationMinutes: number
    notes?: string
}

export interface BookingSettings {
    slotMinutes: number
    clubOpen: string
    clubClose: string
}

export interface UpdateBookingRequest {
    startTime?: string
    durationMinutes?: number
    status?: BookingStatus
}

export interface CheckAvailabilityRequest {
    tableId: number
    startTime: string
    durationMinutes: number
}

export interface CheckAvailabilityResponse {
    available: boolean
    conflictingBookings: Booking[]
}
